import { Box, styled } from '@mui/material';

import { COLORS } from '../../../Constant/COLORS';

const GreyBox = styled(Box)({
  backgroundColor: COLORS.surface,
  border: `1px solid ${COLORS.hairline}`,
  borderRadius: '12px',
});

export default GreyBox;
